(function (angular) {

    angular
        .module('harriApp')
        .controller('TLNotificationsModalController', ["$scope", "$state", "modalData", "TSSideBarService", "TeamCommunicationService", function ($scope, $state, modalData, TSSideBarService, TeamCommunicationService) {

            var tsSideBar = new TSSideBarService($scope);
            var tcService = new TeamCommunicationService($scope);

            $scope.sicknessCount = modalData.sicknessCount;
            $scope.holidayCount = modalData.holidayCount;
            $scope.timeOffCount = modalData.timeOffCount;
            $scope.customCount = modalData.customCount;
            $scope.availabilityCount = modalData.availabilityCount;
            $scope.shiftTradeCount = modalData.shiftTradeCount;
            $scope.myTasksCount = modalData.myTasksCount;
            $scope.loaCount = modalData.loaCount;
            $scope.data = {
                dontShowAgain: false
            }


            $scope.close = function () {
                if ($scope.data.dontShowAgain) {
                    HStorageManager.put({
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                        key: 'hide_tl_requests_modal',
                        value: true,
                        expiryDays: 365
                    });
                }

                $scope.$hide();
            };
        }]);
})
(angular);
